<template>
  <div
    class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center"
  >
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex">
           <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500">
            New subscriber
          </div>
          <div v-else class="text-2xl font-bold text-blue-500">
            Edit subscriber
          </div>
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6">
          <div class="space-y-4 px-10">
            <div
              class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="fullName" class="bg-white text-gray-700 px-1"
                    >Full Name <span :class="$colors.required">*</span></label
                  >
                </p>
              </div>
              <p>
                <input
                  id="fullName"
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.fullName"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
              </p>
            </div>

            <div
              class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="phone" class="bg-white text-gray-700 px-1"
                    >Phone <span :class="$colors.required">*</span></label
                  >
                </p>
              </div>
              <p>
                <input
                  id="phone"
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.phone"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
              </p>
            </div>
              <div
              class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="country" class="bg-white text-gray-700 px-1"
                    >Country (Warehouse)</label
                  >
                </p>
              </div>
             <p>
                  <v-select @input="setSelected" v-model="formData.warehouse" :options="warehouses" label="name">
                      <template slot="option" slot-scope="option">
                          <img class="flag-img" :src="$f.getCountryCode(option.country)"/>
                          {{ $f.getCountryNameByCode(options,option.country)}} 
                      </template>
                  </v-select>
             </p>
            </div>
            <div
              class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
            >
              <div
                class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
              >
                <p>
                  <label for="email" class="bg-white text-gray-700 px-1"
                    >Email <span :class="$colors.required">*</span></label
                  >
                </p>
              </div>
              <p>
                <input
                  id="email"
                  autocomplete="false"
                  tabindex="0"
                  type="text"
                  v-model="formData.email"
                  class="py-2 text-xs px-2 outline-none block h-full w-full"
                />
              </p>
            </div>
          </div>

          <div class="mt-6 pt-3 flex justify-center">
            <button
              class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
              @click="save"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- ******************* Partie Script *********************** -->
<script>
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      formData: {},
      warehouses:[],
      options: this.$countries,
    };
  },
  async mounted() {
    await this.getWarehouses();
    this.dataToEdit();
  },
  methods: {
     RouterBack: function() {
       this.$router.back();
    },
    async getWarehouses(){
        this.warehouses = this.currentUser.warehouses;
        // const filter = {limit:1000};
        // const res = await this.$server.search("warehouses",filter);
        // if (res.content.results) {
        //      this.warehouses = res.content.results;
        // } else this.warehouses = [];
    }, 
    async save() {
      //console.log(this.formData);
      if (this.formData._id) {
        const data = await this.$server.update("subscribers", this.formData);
        if (data && data._id) {
          alert("Subscriber updated", "success");
        }else alert(data, "warning");
      } else {
        if (this.checkData()) {
          const data = await this.$server.create("subscribers", this.formData);
          //console.log("HI souka");
          //console.log(data);

          if (data && data._id) {
            this.formData = {};
            alert("Subscriber created !", "success");
          }else  alert(data, "warning");
        } else {
          alert(`you must fill all the fields !! `, "warning");
        }
      }
    },
    checkData() {
      const requiredFiels = ["fullName", "phone", "email","warehouse"];
      for (let index = 0, len = requiredFiels.length; index < len; index++) {
        if (!(requiredFiels[index] in this.formData)) return false;
      }
      return true;
    },
    setSelected(warhouse) {
      if (warhouse) this.formData.warehouse = warhouse;
      else this.formData.warehouse = null;
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("subscribers", {
          id: this.$route.params.id,
        });
        this.formData = editData.content;
        //console.log(this.formData)
      }
    },
  },
};
</script>

<!-- ******************* Partie style *********************** -->
<style >
</style> 